<script setup lang="ts">
import { getIsCustomizedApp } from '@shared/appConfig';
import KgrIcon from '@shared/components/KgrIcon.vue';
import { openPrivacyPdf } from '@shared/composables/useOpenFile';

// 1:1 port of customer-apps `kgr-privacy-menu-item`: a white-label client with its own privacy
// URL links out, everyone else downloads the API-generated PDF.
const isCustomizedApp = getIsCustomizedApp();
const privacyUrl = window.kgrDynamicConfig.privacyUrl ?? null;
</script>

<template>
    <a
        v-if="isCustomizedApp && privacyUrl"
        :href="privacyUrl"
        target="_blank"
        rel="noopener"
        class="kgr-verticalMenu__item is-level-1"
    >
        <span class="kgr-verticalMenu__itemIcon"><KgrIcon
            name="security"
            :small="true"
        /></span>
        <span class="kgr-verticalMenu__itemLabel">{{ $t('Datenschutz') }}</span>
    </a>
    <button
        v-else
        type="button"
        class="kgr-verticalMenu__item is-level-1"
        @click="openPrivacyPdf()"
    >
        <span class="kgr-verticalMenu__itemIcon"><KgrIcon
            name="security"
            :small="true"
        /></span>
        <span class="kgr-verticalMenu__itemLabel">{{ $t('Datenschutz') }}</span>
    </button>
</template>
